import { AppData } from './../../../services/app-data.service';
import { Assignee } from 'src/app/models/assignee';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

    public assignee: Assignee = this.appData.loggedInAssignee;

    constructor(
        private appData: AppData
    ) { }

    ngOnInit() {

    }

}
